//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

export default {
	/*
	-----仅在APP生效-----
	slide-in-right 新窗体从右侧进入
	slide-in-left  新窗体从左侧进入
	slide-in-top   新窗体从顶部进入
	slide-in-bottom	新窗体从底部进入
	pop-in  新窗体从左侧进入，且老窗体被挤压而出
	fade-in 新窗体从透明到不透明逐渐显示
	zoom-out 新窗体从小到大缩放显示
	zoom-fade-out	新窗体从小到大逐渐放大并且从透明到不透明逐渐显示
	none 无动画
	*/
	type:'zoom-fade-out',
	duration:200
}